import styles from "./__styles__/Tooltip.module.scss";
import { Tooltip } from "./types";

export default ({ tooltip }: { tooltip: Maybe<Tooltip> }) => {
  if (!tooltip) {
    return null;
  }

  return (
    <span
      style={{ top: tooltip.y, left: tooltip.x }}
      className={styles.tooltip}
    >
      {tooltip.text}
    </span>
  );
};
